export const PHONE = "08602227528";
export const WHATSAPP = "918602227528";
export const EMAIL = "parthenterprisesrpr1@gmail.com";
export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP}?text=${encodeURIComponent("Hello Parth Enterprises, I need RO service.")}`;
